<template lang="html">
  <div :class="{egyszazalek:true, open: bodyOpen}">
    <div class="egyszazalek--button" @click="toggleBody">
      <span>1%</span>
    </div>
    <div class="egyszazalek--body"  @click="$router.push('/helpus')">
      <h3>Add nekünk az 1%-od!</h3>
      <p>Neked pár gombnyomás, nekik lehet, hogy az életet jelenti!</p>
      <h3>Adószámunk</h3>
      <h4>123456789-1-23</h4>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      bodyOpen: false,
    }
  },
  methods:{
    toggleBody(){
      this.bodyOpen = !this.bodyOpen;
    }
  }
}
</script>

<style lang="scss" scoped>

.egyszazalek{
  position: fixed;
  z-index: 1000;
  top: 120px;
  left: -275px;
  color: #000;
  text-align: center;
  transition: left 0.4s linear;
  background-color: rgb(222,184,135);
  cursor: pointer;

  &.open{
    left: 0px !important;
    transition: left 0.6s linear;
  }
}
.egyszazalek--button{
  background-color: inherit;
  width: 70px;
  height: 70px;
  position: absolute;
  right: -304px;
  border-radius: 50%;
  display:flex;
  flex-direction: column;
  justify-content: center;

  span{

    text-align: right;
    margin-right: 3px;
    display: block;
    font-size: 18px;
    font-weight: bold;
  }
}

.egyszazalek--body{
  position: absolute;
  background-color: inherit;
  width: 275px;
  padding: 25px;
}
</style>
